const strings = {
  'banners/gameInfo/autoPicks/title': {
    en: 'Scout’s Picks',
    fr: 'Choix des recruteurs',
  },
  'banners/gameInfo/autoPicks/text': {
    en: 'Not sure who to pick and need help?',
    fr: 'Vous avez besoin d’aide pour choisir vos joueurs?',
  },
};

export default strings;
